import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';

const propTypes = {
  children: PropTypes.any.isRequired
};

class RightPanelPortal extends React.Component {
  constructor() {
    super();
    this.node = null;
  }

  componentDidMount() {
    this.node = document.getElementById('right-panel');
    if(this.node) this.forceUpdate();
  }

  render() {
    const { children } = this.props;

    if(!this.node) return null;
    return createPortal(children, this.node);
  }
}

RightPanelPortal.propTypes = propTypes;

export default RightPanelPortal;


// WEBPACK FOOTER //
// ./src/components/RightPanelPortal.jsx